import { render, staticRenderFns } from "./ComboProductImage.vue?vue&type=template&id=f16ff5dc&scoped=true&"
import script from "./ComboProductImage.vue?vue&type=script&lang=js&"
export * from "./ComboProductImage.vue?vue&type=script&lang=js&"
import style0 from "./ComboProductImage.vue?vue&type=style&index=0&id=f16ff5dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f16ff5dc",
  null
  
)

export default component.exports